CONFUSEDCMS = CONFUSEDCMS || {};
CONFUSEDCMS.Breakdown = CONFUSEDCMS.Breakdown || {};

(function (ns, $) {
    'use strict';

    Date.prototype.toInputFormat = function () {
        var yyyy = this.getFullYear().toString();
        var mm = (this.getMonth() + 1).toString(); // getMonth() is zero-based
        var dd = this.getDate().toString();

        var day = parseInt(dd, 10);
        var month = parseInt(mm, 10);
        var year = parseInt(yyyy, 10);
        var date = new Date(year, month - 1, day);

        if (!date.getYear() || !date.getDate()) { return 'dd/mm/yyyy'; }

        return yyyy + '-' + (mm[1] ? mm : '0' + mm[0]) + '-' + (dd[1] ? dd : '0' + dd[0]); // padding
    };

    /* Determine the comparison date.
	   @param  element  (element) the current datepicker element
	   @param  source   (string or Date or jQuery or element) the source of the other date
	   @param  noOther  (boolean) true to not get the date from another field
	   @return  (Date) the date for comparison */
    function extractOtherDate(element, source, noOther) {
        if (source.constructor === Date) {
            return source;
        }
        var inst = $.datepicker._getInst(element);
        var thatDate = null;
        try {
            if (typeof source === 'string' && source !== 'today') {
                thatDate = $.datepicker.parseDate($.datepicker._get(inst, 'dd/mm/yyyy'),
					source, $.datepicker._getFormatConfig(inst));
            }
        }
        catch (e) {
            // Ignore
        }
        thatDate = (thatDate ? thatDate : (source === 'today' ? new Date() :
			(noOther ? null : $(source).datepicker('getDate'))));
        if (thatDate) {
            thatDate.setHours(0, 0, 0, 0);
        }
        return thatDate;
    }

    ns.jQueryValidateExtensions = function () {


        $.validator.addMethod('afterDate',
            function(value, element, params) {

                var thisDate = $(element).datepicker('getDate');
                var thatDate = extractOtherDate(element, params);
                if (!thisDate || !thatDate) {
                    return true;
                }

                return (thisDate > thatDate);
            },
            function(params) {
                return 'Please enter a date after ' + $(params).val() + '.';
            }
        );
        
        $.validator.addMethod('withinAYearOf',
           function (value, element, params) {

               var thisDate = $(element).datepicker('getDate');
               var thatDate = extractOtherDate(value, params);
               if (!thisDate || !thatDate)
               {
                   return true;
               }

               thatDate.setFullYear(thatDate.getFullYear() + 1);

               return (thisDate <= thatDate);
           });

        //Regex Method Validator
        $.validator.addMethod(
            'regex',
            function (value, element, regexp) {
                var re = new RegExp(regexp);
                return this.optional(element) || re.test(value);
            },
            'Please check your input.'
        );

        $.validator.addMethod('notInPast', function(value, element, param) {
            if (!value) {
                return true;
            }
            var dateParts = value.split('/');
            var aDate = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
            var today = new Date();
            today.setHours(0, 0, 0, 0);

            return aDate >= today;
        });

        $.validator.addMethod(
            'notdefault',
            function (value, element, param) {
                var $element = jQuery(element);

                if ($element.is('[type=checkbox]')) {
                    return $element.is(':checked');
                }

                if ($element.is('[type=radio]')) {
                    var checkBoxName = $element.attr('name');
                    return $('[name=' + checkBoxName + ']').is(':checked');
                }

                if (value === param) {
                    return false;
                }

                return true;
            },
            'Please check your input.'
        );

        $.validator.methods.isoDate = function (value) {
            var matches = value.match(/(\d{4})[- \/](\d{1,2})[- \/](\d{1,2})/);
            if (!matches) { return false; }

            // convert pieces to numbers
            // make a date object out of it
            var day = parseInt(matches[3], 10);
            var month = parseInt(matches[2], 10);
            var year = parseInt(matches[1], 10);
            var date = new Date(year, month - 1, day);

            if (!date.getYear() || !date.getDate()) { return false; }

            // make sure we didn't have any illegal 
            // month or day values that the date constructor
            // coerced into valid values
            if (parseInt(date.getMonth() + 1, 10) !== month ||
                date.getFullYear() !== year ||
                date.getDate() !== day) {
                return false;
            }
            return true;
        };

        $.validator.methods.ukDate = function (value) {
            var matches = value.match(/(\d{1,2})[- \/](\d{1,2})[- \/](\d{4})/);
            if (!matches) { return false; }

            // convert pieces to numbers
            // make a date object out of it
            var day = parseInt(matches[1], 10);
            var month = parseInt(matches[2], 10);
            var year = parseInt(matches[3], 10);
            var date = new Date(year, month - 1, day);

            if (!date.getYear() || !date.getDate()) { return false; }

            // make sure we didn't have any illegal 
            // month or day values that the date constructor
            // coerced into valid values
            if (parseInt(date.getMonth() + 1, 10) !== month ||
                date.getFullYear() !== year ||
                date.getDate() !== day) {
                return false;
            }
            return true;
        };

    };

    ns.breakdownModuleRules = function () {

        function addRule(validator, $form, validationRule) {
            var $elem = $form.find(validationRule.selector);

            if ($elem.length !== 0) {
                $elem.rules('add', validationRule.rules);
            }
        }

        var ValidationDefinition = function (selector, rules, message) {
            this.selector = selector;
            this.rules = rules;
            this.message = message;
        };


        function hookupForm($form, validators, options) {
            if (!$form) {
                throw '$form is undefined!';
            }

            //exit early if form isn't found
            if ($form.length === 0) {
                return;
            }
            options = options || {};

            var validator = $form.validate(options);

            for (var i = 0; i < validators.length; i++) {
                var validationRule = validators[i];
                addRule(validator, $form, validationRule);
            }
        }

        var validationRules = {

            VehicleReg: new ValidationDefinition('input#regNumber', {
                regex: '^[a-zA-Z0-9]{2,10}$',
                messages: {
                    regex: 'Please enter a valid vehicle registration number.'
                }
            }),
            CoverStartDate: new ValidationDefinition('input[type=text]#cover-start-date', {
                notdefault: '',
                ukDate: true,
                notInPast: '',
                messages: {
                    notdefault: 'Please enter a start date.',
                    ukDate: 'Please enter a valid start date.',
                    notInPast: 'Cover start date cannot be in the past.'
                }
            }),
            CoverEndDate: new ValidationDefinition('input[type=text]#cover-end-date', {
                notdefault: '',
                ukDate: true,
                afterDate: '#cover-start-date',
                withinAYearOf: '#cover-start-date',
                messages: {
                    notdefault: 'Please enter an end date.',
                    ukDate: 'Please enter a valid end date.',
                    afterDate: 'Cover end date cannot be on or before start date.',
                    withinAYearOf: 'Cover end date must be within a year of the start date.'
                }
            }),
            NativeCoverEndDate: new ValidationDefinition('input[type=date]#cover-end-date', {
                notdefault: 'dd/mm/yyyy',
                isoDate: true,
                afterDate: '#cover-start-date',
                withinAYearOf: '#cover-start-date',
                messages: {
                    notdefault: 'Please enter an end date.',
                    isoDate: 'Please enter a valid end date.',
                    afterDate: 'Cover end date cannot be on or before start date.',
                    withinAYearOf: 'Cover end date must be within a year of the start date.'
                }
            }),
            NativeCoverStartDate: new ValidationDefinition('input[type=date]#cover-start-date', {
                notdefault: 'dd/mm/yyyy',
                isoDate: true,
                messages: {
                    notdefault: 'Please enter a start date.',
                    isoDate: 'Please enter a valid start date.'
                }
            })
        };

        return {
            hookup: hookupForm,
            validationRules: validationRules
        };

    };

    ns.setUpValidation = function ($form) {
        ns.jQueryValidateExtensions();


        var breakdownModuleRules = ns.breakdownModuleRules();
        breakdownModuleRules.hookup($form, [
            breakdownModuleRules.validationRules.VehicleReg,
            breakdownModuleRules.validationRules.CoverStartDate,
            breakdownModuleRules.validationRules.CoverEndDate,
            breakdownModuleRules.validationRules.NativeCoverEndDate,
            breakdownModuleRules.validationRules.NativeCoverStartDate
        ],
        {
            errorElement: 'div',
            errorClass: 'error-message',
            errorPlacement: function (error, element) {
                var errorElement = element.parent().find('div.error-placement');
                if (errorElement.length > 0) {
                    errorElement.append(error);
                } else {
                    element.parent().parent().find('div.error-placement').append(error);
                }

            },
            onfocusout: function (element) {
                if ((!$(element).hasClass('ignore')) && $(element).hasClass('notdefault') || (!this.checkable(element) && (element.name in this.submitted || !this.optional(element)))) {
                    this.element(element);
                }
            },
            onblur: function(element) {
                if ((!$(element).hasClass('ignore')) && $(element).hasClass('notdefault') || (!this.checkable(element) && (element.name in this.submitted || !this.optional(element)))) {
                    this.element(element);
                }
            }

            //ignore: '.ignore'
        });
    };

    ns.breakdownModule = function() {
        var $coverStartDate = $('#cover-start-date'),
              $coverEndDate = $('#cover-end-date');

        if (!Modernizr.touch || !Modernizr.inputtypes.date) {
            $coverStartDate.attr('type', 'text');
            $coverStartDate.addClass('notdefault');
            $coverEndDate.attr('type', 'text');
            $coverEndDate.addClass('notdefault');

            $coverStartDate.datepicker({
                numberOfMonths: 2,
                hideIfNoPrevNext: true,
                duration: '',
                minDate: 0,
                maxDate: 365,
                dateFormat: 'dd/mm/yy',
                onClose: function () {
                    if ($(this).valid()) {
                        var today = new Date();
                        var startDate = $(this).datepicker('getDate');
                        startDate.setDate(startDate.getDate() + 1);
                        $coverEndDate.datepicker('option', 'maxDate', 365);
                        $coverEndDate.datepicker('option', 'minDate', startDate);
                        $(this).datepicker('option', 'minDate', today);
                    } else {
                        $coverEndDate.datepicker('option', 'minDate', 1);
                    }
                }
            });

            $('#cover-end-date').datepicker({
                numberOfMonths: 2,
                hideIfNoPrevNext: true,
                duration: '',
                minDate:1,
                maxDate: 365,
                dateFormat: 'dd/mm/yy',
                onClose: function () {
                    if ($(this).valid()) {
                        var startDate = $(this).datepicker('getDate');
                        startDate.setDate(startDate.getDate() - 1);
                        $coverStartDate.datepicker('option', 'maxDate', startDate);
                    } else
                    {
                        $coverStartDate.datepicker('option', 'maxDate', 365);
                    }
                }
            });
        } else {
            var today = new Date().toInputFormat();
            $coverStartDate.attr('min', today);
            $coverEndDate.attr('min', today);
            $coverStartDate.addClass('notdefault');
            $coverEndDate.addClass('notdefault');

            $coverStartDate.keydown(function (e) {
                if (e.keyCode === 9) {
                    return true;
                }
                return false;
            });

            $coverEndDate.keydown(function (e) {
                if (e.keyCode === 9) {
                    return true;
                }
                return false;
            });

            $coverStartDate.change(function () {
                $(this).valid();
                var startDate = new Date($(this).val());
                var endDate = new Date($(this).val());
                startDate.setDate(startDate.getDate());
                endDate.setDate(endDate.getDate() + 365);
                $coverEndDate.attr('min', startDate.toInputFormat());
                $coverEndDate.attr('max', endDate.toInputFormat());
            });

            $coverEndDate.change(function () {
                $(this).valid();
                var endDate = new Date($(this).val());
                endDate.setDate(endDate.getDate() - 1);
                $coverStartDate.attr('max', endDate.toInputFormat());
            });
        }
    };
}(CONFUSEDCMS.Breakdown, jQuery));